import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function AdminLogin() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: 'admin@gasnaporta.com', password: 'admin123' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role !== 'admin') {
        toast.error('Esta conta não é de administrador');
        return;
      }
      nav('/admin');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao entrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen gradient-hero text-white flex flex-col">
      <div className="px-6 pt-10 pb-8 relative overflow-hidden">
        <div className="absolute inset-0 bg-dots opacity-40 pointer-events-none" />
        <div className="relative">
          <div className="flex justify-center mb-2">
            <img
              src="/logo.png"
              alt="GasNaPorta"
              className="w-72 max-w-full h-auto object-contain logo-glow float-soft"
            />
          </div>
          <div className="text-center">
            <span className="inline-block text-[11px] uppercase tracking-[0.35em] text-sky-200 font-black px-4 py-1.5 rounded-full glass-light">
              Administrativo
            </span>
          </div>
          <h1 className="text-xl font-black text-center mt-5 text-white">Login do Administrador</h1>
          <p className="text-sky-200 text-sm mt-1 text-center">Acesse o painel de gestão</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="flex-1 bg-white text-gray-900 rounded-t-3xl px-6 py-8 space-y-4">
        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Email</label>
          <input
            type="email"
            value={form.email}
            onChange={e => setForm(prev => ({ ...prev, email: e.target.value }))}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Senha</label>
          <input
            type="password"
            value={form.password}
            onChange={e => setForm(prev => ({ ...prev, password: e.target.value }))}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-4 bg-primary hover:bg-primary-dark disabled:opacity-60 rounded-2xl font-bold text-white text-lg transition-all active:scale-95"
        >
          {loading ? 'Entrando...' : 'Entrar no Admin'}
        </button>
      </form>
    </div>
  );
}